import { Button, Flex } from '@aws-amplify/ui-react';
import React from 'react';
import ReactModal from 'react-modal';
import General from '../utils/GeneralUtils';

interface ConfirmRemoveMemberModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  memberName: string;
  memberEmail: string;
  isLoading?: boolean;
}

const ConfirmRemoveMemberModal: React.FC<ConfirmRemoveMemberModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  memberName,
  memberEmail,
  isLoading = false
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={General.getModalDefaults({ width: '500px' })}
      closeTimeoutMS={200}
      parentSelector={General.getModalRoot}
    >
      <Flex direction='column' gap={20}>
        <h2 style={{ marginTop: 0, marginBottom: 0 }}>
          Remove {memberName}?
        </h2>
        <div>
          Are you sure you want to remove <strong style={{ color: 'var(--amplify-colors-yellow-60)' }}>{memberEmail}</strong> from the team?
        </div>
        <div>
          This will disable their account and they will lose access immediately.
        </div>
        <div className='desc-9'>
          This action can be reverted and the member can be invited back if needed.
        </div>
        <Flex gap={10} justifyContent='flex-end'>
          <Button
            size='small'
            variation='destructive'
            onClick={onConfirm}
            isLoading={isLoading}
            loadingText='Removing...'
          >
            Remove User
          </Button>
        </Flex>
      </Flex>
    </ReactModal>
  );
};

export default ConfirmRemoveMemberModal;
